<template>
    <page :loading="$wait.waiting(keys.auth.verify)">
        <template v-if="verificationFailed" #title>{{$t('pages.dashboard.account.verify.title')}}</template>
        <template v-if="verificationFailed" #content>
            <v-card class="pa-2">
                <v-card-text>
                    <p>{{msg}}</p>
                </v-card-text>
            </v-card>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";

    import {createNamespacedHelpers} from 'vuex';

    const {mapActions} = createNamespacedHelpers('auth');
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import notifications from "@mixins/includes/_notifications";
    import EButtonPrimary from "@elements/buttons/theme/e-button-primary";

    export default {
        name: "dashboard-account-verify",
        components: {EButtonPrimary, Page},
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.account.verify.meta.title')
            }
        },
        data() {
            return {
                msg: '',
                verificationFailed: false
            }
        },
        mixins: [vuexKeys, notifications],
        async created() {
            try {
                await this.verify({hash: this.$route.params.hash});
                this.notify.success(this.$t('notifications.profile.email-confirmation.success'));
                if(this.authenticated){
                    this.$router.push(this.nav.dashboard.index.path)
                } else {
                    this.$router.push(this.nav.dashboard.login.path())
                }
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    this.verificationFailed = true;
                    this.msg = this.$t('notifications.profile.email-confirmation.error')
                    this.notify.error(this.$t('notifications.profile.email-confirmation.error'));
                }
            }
        },
        methods: {
            ...mapActions(['verify'])
        }
    }
</script>

<style lang="scss" scoped>
    .v-btn {
        margin-left: auto;
        width: auto;
    }
</style>
